import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const sceneData = (state: RootState) => state.pages.editor.scene;

const isScenePublished = createSelector([sceneData], (data) => data.latestVersionId === data.publishedVersionId);

export default isScenePublished;
